// @ts-nocheck
import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { useSelector } from "react-redux";
import {
  User,
  Search,
  MessageCircle,
  Newspaper,
  Bell,
  Plus,
  Menu,
  X,
  MessageCircleCode,
} from "lucide-react";

import Login from "./screens/Login";
import PostFeedScreen from "./components/Post";
import MainSearch from "./screens/MainSearch";
import { ToastContainer } from "react-toastify";
import { useAppSelector } from "./hooks/useRedux";
import RegisterScreen from "./screens/Register";
import CompleteProfile from "./screens/CompleteProfile";
import Header from "./components/Header";
import Notifications from "./screens/Noticiations";
import CodeVerificationScreen from "./screens/RegisterCode";
import UserProfileScreen from "./screens/Profile";
import PublicProfile from "./screens/PublicProfile";
import Welcome from "./screens/Welcome";
import Logout from "./screens/Logout";
import ChangePassword from "./screens/ChangePassword";
import { ForgetPassword } from "./screens/ForgotPassword";
import { VerifyCode } from "./screens/VerifyCode";
import DeleteAccount from "./screens/DeleteAccount";
import PostPreview from "./screens/PostPreview";
import SearchScreen from "./screens/SearchScreen";
import CoachPublicProfile from "./screens/coach-screens/CoachPublicProfile";
import CoachProfile from "./screens/coach-screens/CoachProfile";
import CreatePost from "./screens/CreatePost";
import BlockedUsers from "./screens/BlockedUsers";
import ChatListScreen from "./screens/ChatListScreen";
import ChatScreen from "./screens/ChatScreen";
import { useLocation } from "react-router-dom";
import LiveStreamScreen from "./screens/LiveStreamScreen";

// function PrivateRoute({ children }) {
//   const user = useAppSelector((state) => state.user);
//   return user?.email ? children : <Navigate to="/login" replace />;
// }
function PrivateRoute({ children, role }) {
  const user = useAppSelector((state) => state.user);
  if (user === null) return null;
  if (role && user?.email && user?.role !== role) {
    return <Navigate to="/feeds" replace />;
  }
  return user?.email ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const user = useAppSelector((state) => state.user);
  return user?.email ? <Navigate to="/feeds" replace /> : children;
}

const LeftSidebar = ({ userPosts }) => {
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.user);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const navItems = [
    { label: "Feeds", icon: <Newspaper className="w-5 h-5" />, path: "/feeds" },
    {
      label: "My Profile",
      icon: <User className="w-5 h-5" />,
      path: user?.role === "coach" ? "/profile-coach" : "/profile",
    },
    {
      label: "Sports Search",
      icon: <Search className="w-5 h-5" />,
      path: "/MainSearch",
    },
    {
      label: "Notifications",
      icon: <Bell className="w-5 h-5" />,
      path: "/notifications",
    },
    {
      label: "Chat",
      icon: <MessageCircle className="w-5 h-5" />,
      path: "/chat-list",
    },
    {
      label: "Create Post",
      icon: <Plus className="w-5 h-5" />,
      path: "/create-post",
    },
  ];

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      {/* Hamburger Button for Mobile/Tablet */}
      <button
        className="md:hidden fixed top-3 left-4 z-50 p-2 text-white bg-[#1a1a1a] rounded-lg"
        onClick={toggleSidebar}
      >
        {isSidebarOpen ? (
          <X className="w-6 h-6" />
        ) : (
          <Menu className="w-6 h-6" />
        )}
      </button>

      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 w-64 bg-[#0f0f0f] border-r border-gray-800 p-6 shadow-lg transform ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0 md:static md:w-[30%] transition-transform duration-300 ease-in-out z-40 h-screen overflow-y-auto`}
      >
        {/* Navigation Items */}
        <ul className="space-y-3 mt-12 md:mt-0">
          {navItems.map((item, index) => (
            <li
              key={index}
              onClick={() => {
                navigate(item.path);
                setIsSidebarOpen(false);
              }}
              className="flex items-center gap-4 px-4 py-2 rounded-lg text-white cursor-pointer transition-all duration-200 hover:bg-[#1a1a1a] hover:text-[#C00000]"
            >
              {item.icon}
              <span className="text-md font-medium">{item.label}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Dim Background Overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
          onClick={toggleSidebar}
        ></div>
      )}
    </>
  );
};
const MainLayout = ({ children }) => {
  const userPosts = useAppSelector((state) => state.posts);
  const location = useLocation();
  const isChatScreen = location.pathname.includes("/chat-screen");
  const isPreviewScreen = location.pathname.includes("post-preview");

  return (
    <div className="flex flex-col h-screen">
      {/* Top Header */}
      <Header />

      {/* Main content area: sidebar + page content */}
      <div
        className={`flex flex-1 ${
          isChatScreen || isPreviewScreen ? "" : "overflow-hidden"
        }`}
      >
        {/* <div className={`flex flex-1 overflow-hidden`}> */}
        <LeftSidebar userPosts={userPosts} />

        <div className="w-full bg-black overflow-y-auto">{children}</div>
      </div>
    </div>
  );
};

function App() {
  const user = useAppSelector((state) => state.user);

  console.log("user role: ", user.role);

  console.log(user, "yseruseur");

  return (
    <Router>
      <Routes>
        {/* Default route */}
        <Route
          path="/"
          element={
            user?.email ? (
              <Navigate
                to={user.role === "coach" ? "/feeds" : "/feeds"}
                replace
              />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Public login route */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/verify-new-user"
          element={
            <PublicRoute>
              <CodeVerificationScreen />
            </PublicRoute>
          }
        />
        <Route
          path="/register"
          element={
            <PublicRoute>
              <RegisterScreen />
            </PublicRoute>
          }
        />
        <Route
          path="/complete-profile"
          element={
            <PublicRoute>
              <CompleteProfile />
            </PublicRoute>
          }
        />

        <Route
          path="/change-password"
          element={
            <PublicRoute>
              <ChangePassword />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgetPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/verify-code"
          element={
            <PublicRoute>
              <VerifyCode />
            </PublicRoute>
          }
        />
        <Route
          path="/welcome"
          element={
            <PublicRoute>
              <Welcome />
            </PublicRoute>
          }
        />

        {/* Protected Routes */}
        <Route
          path="/feeds"
          element={
            <PrivateRoute>
              <MainLayout>
                <PostFeedScreen />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/post-preview"
          element={
            <PrivateRoute>
              <MainLayout>
                <PostPreview />
              </MainLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/live-stream"
          element={
            <PrivateRoute>
              <MainLayout>
                <LiveStreamScreen />
              </MainLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/search-screen"
          element={
            <PrivateRoute>
              <MainLayout>
                <SearchScreen />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/logout"
          element={
            <PrivateRoute>
              <MainLayout>
                <Logout />
              </MainLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/change-password-user"
          element={
            <PrivateRoute>
              <MainLayout>
                <ChangePassword />
              </MainLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/delete-account"
          element={
            <PrivateRoute>
              <MainLayout>
                <DeleteAccount />
              </MainLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/blocked-users"
          element={
            <PrivateRoute>
              <MainLayout>
                <BlockedUsers />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <MainLayout>
                <UserProfileScreen />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/public-profile"
          element={
            <PrivateRoute>
              <MainLayout>
                <PublicProfile />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/MainSearch"
          element={
            <PrivateRoute>
              <MainLayout>
                <MainSearch />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/Notifications"
          element={
            <PrivateRoute>
              <MainLayout>
                <Notifications />
              </MainLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/create-post"
          element={
            <PrivateRoute>
              <MainLayout>
                <CreatePost />
              </MainLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/chat-list"
          element={
            <PrivateRoute>
              <MainLayout>
                <ChatListScreen />
              </MainLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/chat-screen"
          element={
            <PrivateRoute>
              <MainLayout>
                <ChatScreen />
              </MainLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/MainSearch"
          element={
            <PrivateRoute>
              <MainSearch />
            </PrivateRoute>
          }
        />
        {/* <Route
          path="/create-post"
          element={
            <PrivateRoute>
              <CreatePost />
            </PrivateRoute>
          }
        /> */}

        {/* Coach-specific Routes */}
        <Route
          path="/coach-public-profile"
          element={
            <PrivateRoute>
              <MainLayout>
                <CoachPublicProfile />
              </MainLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/profile-coach"
          element={
            <PrivateRoute>
              <MainLayout>
                <CoachProfile />
              </MainLayout>
            </PrivateRoute>
          }
        />

        {/* Catch-all fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <ToastContainer />
    </Router>
  );
}

export default App;
